import Component from "../../lib/component";

export const WaveContainerConfig = {
    componentTypeKey: 'WaveContainer',
    baseHtmlClass: 'wavesbox__waves',
    selector: '.wavesbox__waves',
};

export class WaveContainer extends Component {

    static createWaveContainerElement(parentElement) {
        const element = document.createElement('div');
        element.classList.add(WaveContainer.config.baseHtmlClass);
        parentElement.appendChild(element);
        return element;
    }

    static get config() {
        return WaveContainerConfig;
    }

    constructor(id_or_element, wavesbox, options = {}) {
        super({
            element: id_or_element,
            config: WaveContainer.config
        });

        this.wavesbox = wavesbox;

        this.render();
    }

    render() {
    }

}